import React from 'react';
import globals from '../constants/globals.js';
import { branch } from 'baobab-react/higher-order';
import PropTypes from 'baobab-react/prop-types';
import * as actions from '../actions/actions';
import * as actionsPortal from '../actions/portalActions';
import * as awsS3 from '../persistence/s3';
import * as algolia from '../search/algolia';
import { Button, Dropdown, MenuItem, Glyphicon, Panel } from 'react-bootstrap';

import Card from '../components/card/app-card.js';
import Alerts from '../components/app-alerts.js';

import FontAwesome from 'react-fontawesome';

import Flexbox from 'flexbox-react';
import browserHistory from '../history';

import NavLinks from './navPanel/app-nav-links.js';
import NavPanel from './navPanel/app-nav-panel.js';

import { WithContext as ReactTags } from 'react-tag-input';

import MediaQuery from 'react-responsive';

//import shallowCompare from 'react-addons-shallow-compare';

import StripeCheckout from 'react-stripe-checkout';

import Modal from 'react-responsive-modal';

import ChecklistReadOnly from './app-checklist-read-only.js';

import * as utils from '../utils/utils';

import Loader from 'react-loader-advanced';


class Home extends React.PureComponent {
	constructor(props, context) {
		super(props, context);

		if (!props.user.loggedIn) {
			actions.forceLogin(browserHistory, this.props.location.pathname);
		} else {
			this.handleBuy = this.handleBuy.bind(this);
			this.handleAdd = this.handleAdd.bind(this);
			this.openPreviewModal = this.openPreviewModal.bind(this);
			this.closePreviewModal = this.closePreviewModal.bind(this);
		}

		this.state = {
			featuredOpen: true,
			featuredSimsOpen: true,
			featuredSnippetsOpen: true,
			checkMateOpen: true
		}
	}

	_add(hit) {
		awsS3.clonePublicDocument(hit);
	}

	_onToken = (token, hit) => {
		awsS3.saveStripeToken(token, hit);
	}

	handleBuy(item) {
	}

	handleAdd(item) {
		awsS3.clonePublicDocument(item);
	}

	closePreviewModal() {
		this.props.dispatch(
			actions.closePreviewModal
		);
	}

	openPreviewModal(hit) {
		this.props.dispatch(
			actions.openPreviewModal,
			hit
		);
	}
	/*
		shouldComponentUpdate(nextProps, nextState) {
			return shallowCompare(this, nextProps, nextState);
		}
	*/
	getHits(searchHits, type) {
		var self = this;
		var hits = searchHits.map(function (hit, i) {
			var menuItems = [
				<MenuItem key={"menuitem1"} eventKey="1" onClick={(e) => { e.stopPropagation(); self.openPreviewModal(hit) }}>Preview</MenuItem>,
			];

			var addButton;
			if (hit.publisher === "checkmate") {
				var addButtonCloud =
					<div style={{ display: "flex" }}>
						<StripeCheckout
							name="MiraCheck"
							description={hit.name}
							image={"assets/checkmate_logo_only_no_border_space_128x128.png"}
							token={(token) => { self._onToken(token, hit) }}
							stripeKey={globals.stage === "prod" ? globals.stripeKeyProd : globals.stripeKeyDev}
							amount={1500}
							email={self.props.user.email}
							ComponentClass="div"
						>
							<Button style={{ color: "#0E7AFE", fontWeight: "bold" }}>Buy</Button>
						</StripeCheckout>
						{/* 
					<a style={{marginLeft: "5px"}} href="javascript:alert('This is a test sandbox so you will not actually be charged. For the credit card enter 4242-4242-4242-4242, for expiration enter any future date and for CVC enter any three numbers.')">?</a>
					*/}
					</div>

				var addButtonMobile =
					<div style={{ display: "flex" }}>
						<Button onClick={(e) => { alert("To purchase premium content please login to the MiraCheck website through a web browser.") }} style={{ color: "#0E7AFE", fontWeight: "bold" }}>Info</Button>
					</div>

				// Probably better way to know if launched from mobile app
				// var mobile = false;

				// try {
				// 	window.webkit.messageHandlers.reactNative.postMessage(JSON.stringify({ method: "dummy" }));
				// 	mobile = true;
				// } catch (e) {
				// }
				// // UIWebView
				// try {
				// 	window.postMessage(JSON.stringify({ method: "dummy" }));
				// 	mobile = true;
				// } catch (e) {
				// }

				// if (utils.isMobile()) {
				// 	addButton = addButtonMobile;
				// } else {
				addButton = addButtonCloud;
				// }
			} else {
				addButton =
					<Button onClick={() => { self._add(hit) }}>Add</Button>
			}

			var menuComponent =
				<Dropdown pullRight id="dropdown-card-menu">
					<Dropdown.Toggle noCaret onClick={(e) => { e.stopPropagation() }}>
						<Glyphicon style={{ color: "#fdfdfd" }} glyph="option-vertical" />
					</Dropdown.Toggle>
					<Dropdown.Menu style={{ opacity: 0.95 }}>
						{menuItems}
					</Dropdown.Menu>
				</Dropdown>;

			var card =
				<Card
					title={hit.name}
					// title={hit.name + "; " + hit.id}
					description={hit.description}
					contributors={hit.hasOwnProperty("contributors") ? hit.contributors : []}
					privacy="public"
					menuComponent={menuComponent}
					disabled={false}
					visible={true}
					genres={self.props.genres}
					genre={hit.genre}
					onClick={(e) => { }}
					addButton={addButton}
					compact={true}>
				</Card>;

			return (
				<div key={type + "Hit" + i}>{card}</div>
			);
		});

		return hits;
	}


	render() {
		var self = this;
		if (!this.props.user.loggedIn) {
			return (
				<div />
			);
		} else {
			var self = this;
			var modalStyle = {
				modal: {
					width: "75%",
					maxWidth: 800,
					position: 'relative',
					padding: '1.2rem',
					background: '#0000ff',
					backgroundClip: 'padding-box',
					boxShadow: '0 12px 15px 0 rgba(0,0,0,0.25)',
				}
			};

			var previewModal;
			previewModal =
				<Modal classNames={{ modal: 'custom-modal' }} open={this.props.previewChecklist.showModal} onClose={this.closePreviewModal} little>
					<h3 style={{ textAlign: "center" }}>Preview</h3>
					<div style={{ height: "70vh", overflow: "auto" }}>
						<ChecklistReadOnly checklist={this.props.previewChecklist.checklist} preview={true} />
					</div>
				</Modal>

			var featuredHits = this.getHits(this.props.search.featured, "featured");
			var featuredSimsHits = this.getHits(this.props.search.featuredSims, "featuredSims");
			var featuredSnippetsHits = this.getHits(this.props.search.featuredSnippets, "featuredSnippets");
			var checkmateHits = this.getHits(this.props.search.checkmate, "checkmate");
			var trendingHits = this.getHits(this.props.search.trending, "trending");
			var recommendedHits = this.getHits(this.props.search.recommended, "recommended");

			var header = (
				<div>
					<div style={{ marginTop: "5px" }}>
						MiraCheck Mission&nbsp;<Glyphicon glyph="info-sign" />
					</div>
				</div>
			)

			var chevronDown = <span><Glyphicon glyph='chevron-down' /></span>;
			var chevronUp = <span><Glyphicon glyph='chevron-up' /></span>;

			var featuredHeader = (
				<div onClick={() => this.setState({ featuredOpen: !this.state.featuredOpen })}>
					<div style={{ marginTop: "5px", float: "left" }}>
						Community Checklists - Made by Fellow Aviators
					</div>
					<div style={{ float: "right" }}>
						<Button bsSize="small">{this.state.featuredOpen ? chevronUp : chevronDown}</Button>
					</div>
					<div style={{ float: "none", clear: "both" }} />
				</div>
			)

			var featuredSimsHeader = (
				<div onClick={() => this.setState({ featuredSimsOpen: !this.state.featuredSimsOpen })}>
					<div style={{ marginTop: "5px", float: "left" }}>
						Flight Simulator Community Procedures
					</div>
					<div style={{ float: "right" }}>
						<Button bsSize="small">{this.state.featuredSimsOpen ? chevronUp : chevronDown}</Button>
					</div>
					<div style={{ float: "none", clear: "both" }} />
				</div>
			)

			var featuredSnippetsHeader = (
				<div onClick={() => this.setState({ featuredSnippetsOpen: !this.state.featuredSnippetsOpen })}>
					<div style={{ marginTop: "5px", float: "left" }}>
						Aviation Related Snippets & Examples
					</div>
					<div style={{ float: "right" }}>
						<Button bsSize="small">{this.state.featuredSnippetsOpen ? chevronUp : chevronDown}</Button>
					</div>
					<div style={{ float: "none", clear: "both" }} />
				</div>
			)

			var checkMateHeader = (
				<div onClick={() => this.setState({ checkMateOpen: !this.state.checkMateOpen })}>
					<div style={{ marginTop: "5px", float: "left" }}>
						CheckMate Aviation Originals - Digital Copies of CheckMate Cards
					</div>
					<div style={{ float: "right" }}>
						<Button bsSize="small">{this.state.checkMateOpen ? chevronUp : chevronDown}</Button>
					</div>
					<div style={{ float: "none", clear: "both" }} />
				</div>
			)

			var featuredPanel =
				<Panel defaultExpanded bsStyle="success">
					<Panel.Heading>
						<Panel.Title toggle>
							{featuredHeader}
						</Panel.Title>
					</Panel.Heading>
					<Panel.Collapse>
						<Panel.Body>
							<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
								<div style={{ maxWidth: "800px", textAlign: "left", backgroundColor: "#666666", border: "1px solid #666666", borderRadius: "10px", padding: "10px" }}>
									Goose - Your Digital Co-PIlot is an ecosystem for the community to create aircraft, checklists & procedures. We highly encourage the sharing of those checklists. Here are some of the checklists Goose pilots have created. If you want to find more, you can go to Search to browse everything that’s available. Please cross-check the content, to make sure these procedures reflect both your personal and aircraft’s needs.
									On that note: Please help the community by creating your checklists and share them with other pilots through making them public! Thanks.
								</div>
							</div>
							<MediaQuery query='(max-width: 1089px)'>
								<Flexbox padding="10px" flexDirection="row" flexWrap="wrap" justifyContent="center">
									{featuredHits}
								</Flexbox>
							</MediaQuery>
							<MediaQuery query='(min-width: 1090px)'>
								<Flexbox padding="10px" flexDirection="row" flexWrap="wrap" justifyContent="flex-start">
									{featuredHits}
								</Flexbox>
							</MediaQuery>
						</Panel.Body>
					</Panel.Collapse>
				</Panel>;

			var featuredSimsPanel =
				<Panel defaultExpanded bsStyle="success">
					<Panel.Heading>
						<Panel.Title toggle>
							{featuredSimsHeader}
						</Panel.Title>
					</Panel.Heading>
					<Panel.Collapse>
						<Panel.Body>
							<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
								<div style={{ maxWidth: "800px", textAlign: "left", backgroundColor: "#666666", border: "1px solid #666666", borderRadius: "10px", padding: "10px" }}>
									These checklist are designed for simulation use. They may serve as starting points for your own airplane, but if used in aircraft operations outside the simulator, please cross-check the content with your POH.								</div>
							</div>
							<MediaQuery query='(max-width: 1089px)'>
								<Flexbox padding="10px" flexDirection="row" flexWrap="wrap" justifyContent="center">
									{featuredSimsHits}
								</Flexbox>
							</MediaQuery>
							<MediaQuery query='(min-width: 1090px)'>
								<Flexbox padding="10px" flexDirection="row" flexWrap="wrap" justifyContent="flex-start">
									{featuredSimsHits}
								</Flexbox>
							</MediaQuery>
						</Panel.Body>
					</Panel.Collapse>
				</Panel>;

			var featuredSnippetsPanel =
				<Panel defaultExpanded bsStyle="success">
					<Panel.Heading>
						<Panel.Title toggle>
							{featuredSnippetsHeader}
						</Panel.Title>
					</Panel.Heading>
					<Panel.Collapse>
						<Panel.Body>
							<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
								<div style={{ maxWidth: "800px", textAlign: "left", backgroundColor: "#666666", border: "1px solid #666666", borderRadius: "10px", padding: "10px" }}>
									These are checklist just snippets and examples - mostly without context. If needed, add them to My Checklists. From there you can copy and paste them into your own aircraft where needed.
									We provided a detailed description on how to copy a snipped in the linked post in our forum. <br /><br /><a onClick={(e) => utils.openUrl(e, "https://forum.miralouaero.com/t/adding-a-snippet-to-a-checklist/270/2?u=admin")} href="javascript:void(0)" style={{ color: "white", fontWeight: "bold", textDecoration: "underline" }}>How to Copy a Snippet</a>
								</div>
							</div>
							<MediaQuery query='(max-width: 1089px)'>
								<Flexbox padding="10px" flexDirection="row" flexWrap="wrap" justifyContent="center">
									{featuredSnippetsHits}
								</Flexbox>
							</MediaQuery>
							<MediaQuery query='(min-width: 1090px)'>
								<Flexbox padding="10px" flexDirection="row" flexWrap="wrap" justifyContent="flex-start">
									{featuredSnippetsHits}
								</Flexbox>
							</MediaQuery>
						</Panel.Body>
					</Panel.Collapse>
				</Panel>;


			var checkMatePanel =
				<Panel defaultExpanded bsStyle="info">
					<Panel.Heading>
						<Panel.Title toggle>
							{checkMateHeader}
						</Panel.Title>
					</Panel.Heading>
					<Panel.Collapse>
						<Panel.Body>
							<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
								<div style={{ maxWidth: "800px", textAlign: "left", backgroundColor: "#666666", border: "1px solid #666666", borderRadius: "10px", padding: "10px" }}>
									We have partnered with CheckMate Aviation to bring their world class checklist content to Goose - Your Digital Co-Pilot. If you prefer the proven track record of a company like CheckMate you can now purchase a digital copy of the original CheckMate plastic card. There are currently over 100 airplanes available for purchase for $15. Since you are purchasing copyrighted content, you will not be able to share publicly any customisations you make, nor print the checklist.								</div>
							</div>
							<MediaQuery query='(max-width: 1089px)'>
								<Flexbox padding="10px" flexDirection="row" flexWrap="wrap" justifyContent="center">
									{checkmateHits}
								</Flexbox>
							</MediaQuery>
							<MediaQuery query='(min-width: 1090px)'>
								<Flexbox padding="10px" flexDirection="row" flexWrap="wrap" justifyContent="flex-start">
									{checkmateHits}
								</Flexbox>
							</MediaQuery>
						</Panel.Body>
					</Panel.Collapse>
				</Panel>;

			var panel1, panel2, panel3, panel4;
			if (this.props.urlParams.partner != null && this.props.urlParams.partner.toLowerCase() === "checkmate") {
				panel1 = checkMatePanel;
				panel2 = featuredPanel;
				panel3 = featuredSimsPanel;
				panel4 = featuredSnippetsPanel;
			} else {
				panel1 = featuredPanel;
				panel4 = featuredSimsPanel;
				panel3 = featuredSnippetsPanel;
				panel2 = checkMatePanel;
			}

			var home;
			home =
				<div style={{ padding: "10px" }}>
					{/* <Panel bsStyle="primary">
						<Panel.Heading>
							<Panel.Title toggle>
								MiraCheck Mission&nbsp;<Glyphicon glyph="info-sign" />
							</Panel.Title>
						</Panel.Heading>
						<Panel.Collapse>
							<Panel.Body>
								<p style={{ fontSize: "16pt", fontWeight: "bold", fontStyle: "italic" }}>The future of checklists is here!</p>
								<p>Technology is at the intersection of so many ground-breaking technologies, from the cloud, to mobile, to voice assistants, to computers on our wrist. <b>MiraCheck</b> combines all of these innovations to unleash the potential of such a simple concept.</p>
								<p><b>Goose Cloud</b> is where you <i>discover</i>, <i>create</i>, <i>edit</i> and <i>share</i> checklist content.</p>
								<p>Goose Cloud aims to be a central hub for the community to share their expertise. It has robust editing tools as well as a powerful search engine to easily discover checklist procedures.</p>
								<p>The ultimate goal of a tool like MiraCheck is to reduce human-error and enable people on new procedures in the most efficient way possible.</p>
								<p>The ultimate vision is learning checklists. When you are initially learning a new procedure there is a lot of detail and it walks you through the process in a very methodical way. Basically, it can act as a performance support tool for real-time on-the-job training. As you gain more experience, then the checklist acts more as an accountability tool and as a tool to reduce mistakes.</p>
								<p>For this reason, checklist content for procedures should constantly be improved, and there are many features around this premise. Every time you interact with a checklist a session is created and historical record of all actions. This history can help you identify the flaws in procedures to improve them for the future. This history can also act as an accountability mechanism.</p>
								<p>The companion mobile app <b>MiraCheck CoPilot</b> is where you interact with all the great content created on Goose Cloud. Digital assistants are becoming commonplace, and MiraCheck CoPilot embraces this trend. It utilizes voice (Mira) to try to combat the complacency that can occur when you check the same items over and over. It was designed to take you through the content in the most efficient way possible. It also provides a framework for much richer checklist content. Items can be textual content, URL links, images and videos. More detailed rich content can also be associated with each item.</p>
							</Panel.Body>
						</Panel.Collapse>
					</Panel> */}
					<Panel defaultExpanded bsStyle="primary">
						<Panel.Heading style={{ backgroundColor: "royalblue", color: "white" }}>
							<Panel.Title>
								General News & Latest Information&nbsp;<Glyphicon glyph="info-sign" />
							</Panel.Title>
						</Panel.Heading>
						<Panel.Collapse>
							<Panel.Body>
								<p>Welcome to Goose - Your Digital Co-Pilot.</p>

								<p>A New Era in Aviation: AeroSys Technologies Inc. and MiraLou Aero LLC Merger.</p>

								<p>Full blown AI Voice CoPilot about to be released! Pilots now enabled to access all checklists, all airport & navigation information and much more via voice only!</p>

								<p>The system is often referred to as the “Alexa for pilots” – an extraordinary boost in both a pilot’s comfort and safety.</p>

								<p>View the full press release <a onClick={(e) => utils.openUrl(e, "https://flysnf.org/press-release/a-voice-assistant-for-pilots/")} href="javascript:void(0)">here</a>.</p>

							</Panel.Body>
						</Panel.Collapse>
					</Panel>
					{!this.props.igapp &&
						<div style={{ textAlign: "center" }}>
							<h3>Browse Existing Aircraft, Checklists & Procedures</h3>
							<p>Purchase premium content, choose open-source checklists provided by the community and fellow pilots and browse special procedures</p>
						</div>
					}
					{panel1}
					{panel2}
					{panel3}
					{!this.props.igapp && panel4}
				</div>

			const spinner =
				<FontAwesome
					name='spinner'
					size='4x'
					spin />;

			return (
				<Loader show={this.props.loadingSpinner} message={spinner}>
					<Flexbox flexDirection="column" height="100vh" style={{ minHeight: 0 }}>
						<Alerts />
						<NavLinks />
						<MediaQuery query='(max-width: 599px)'>
							<Flexbox flex="1" flexDirection="row" width="100vw" style={{ minHeight: 0 }}>
								<Flexbox style={{ overflowY: "auto", width: "100%" }} padding="10px" flexDirection="column" flexGrow={1} alignItems="center" justifyContent="flex-start">
									{home}
								</Flexbox>
							</Flexbox>
						</MediaQuery>
						<MediaQuery query='(min-width: 600px)'>
							<Flexbox flex="1" flexDirection="row" width="100vw" style={{ minHeight: 0 }}>
								<MediaQuery query='(min-width: 768px)'>
									<NavPanel />
								</MediaQuery>
								<Flexbox style={{ overflowY: "auto", width: "100%" }} padding="10px" flexDirection="column" flexGrow={1} justifyContent="flex-start">
									{home}
								</Flexbox>
							</Flexbox>
						</MediaQuery>
						{previewModal}
					</Flexbox>
				</Loader>
			);
		}
	}

	componentDidMount() {
		this.context.tree.select(['appState', 'navPanel']).set('selected', 'home');
	}
}

Home.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	urlParams: ["appState", "urlParams"],
	user: ["user"],
	genres: ["genres"],
	search: ['search'],
	recent: ['recent'],
	previewChecklist: ['appState', 'previewChecklist'],
	loadingSpinner: ['appState', 'loadingSpinner'],
	igapp: ["appCapabilities", "igapp"]
}, Home);